import React from "react";
import ChartistGraph from "react-chartist";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Nav,
  Tab,
} from "react-bootstrap";
import { Label } from "reactstrap";

import ReactDatetime from "react-datetime";

import moment from "moment";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLabel,
  VictoryLegend,
  VictoryTheme,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from "victory";

import DetailKaltimtara from "./DashboardDetailKaltimtara";
import DetailKalsel from "./DashboardDetailKalsel";
import DetailKalteng from "./DashboardDetailKalteng";
import DetailSulutgo from "./DashboardDetailSulutgo";
// import { getTotalTargetUserKaltimtara } from "stores/bpdKaltimtara/Pengajuan/function";
// import { getGrafikPencairanUserKaltimtara } from "stores";
// import { getAllTotalSupervisorKaltimtara } from "stores";
// import { getAllTotalMarketingKaltimtara } from "stores";
// import { getAllTotalCabangKaltimtara } from "stores";

//=======================KALTIMTARA==========================

import { getTotalPencairanKaltimtara } from "stores/bpdKaltimtara/Pengajuan/function";
import { getTotalTargetUserKaltimtara } from "stores/bpdKaltimtara/Pengajuan/function";
// import { getGrafikPencairanUserKaltimtara } from "stores/bpdKaltimtara/dashboardUtama/function";

//======================KALTENG=============================
import { getTotalTargetUserKalteng } from "stores/bpdKalteng/Pengajuan/function";
import { getTotalPencairanKalteng } from "stores/bpdKalteng/Pengajuan/function";

//=====================SULUTGO==============================
import { getTotalPencairanSulutgo } from "stores/bpdSulutgo/Pengajuan/function";
import { getTotalTargetUserSulutgo } from "stores/bpdSulutgo/Pengajuan/function";

//=====================KALSEL==============================
import { getTotalPencairanKalsel } from "stores/bpdKalsel/Pengajuan/function";
import { getTotalTargetUserKalsel } from "stores/bpdKalsel/Pengajuan/function";

function DashboardUtama() {
  const [openKaltim, setOpenKaltim] = React.useState(false);
  const [openKalsel, setOpenKalsel] = React.useState(false);
  const [openKalteng, setOpenKalteng] = React.useState(false);
  const [openSulutgo, setOpenSulutgo] = React.useState(false);
  const [openKaltimCard, setOpenKaltimCard] = React.useState(true);
  const [openKalselCard, setOpenKalselCard] = React.useState(true);
  const [openKaltengCard, setOpenKaltengCard] = React.useState(true);
  const [openSulutgoCard, setOpenSulutgoCard] = React.useState(true);
  //=========================KALTIMTARA=============================
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const cardTotalAreaManagerKaltimtara = useSelector(
    (state) => state.dashboardUtamaReducerKaltimtara,
  );
  // const cardTotalPencairan = useSelector((state) => state.pengajuanReducer);
  // console.log(cardTotalPencairan.data, "Dari Store");

  const formatRupiah = (angka) => {
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const [dataGrafikUserKaltimtara, setDataGrafikUserKaltimtara] =
    React.useState([]);
  const totalTargetKaltimtara = hasilPresentaseKaltimtara > 100;
  const [totalNominalPencairanKaltimtara, setTotalNominalPencairanKaltimtara] =
    React.useState(0);
  const [hasilPresentaseKaltimtara, setHasilPresentaseKaltimtara] =
    React.useState(0);
  const [totalNominalTargetKaltimtara, setTotalNominalTargetKaltimtara] =
    React.useState(0);

  const [dariTgl, setDariTgl] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );

  const [smpTgl, setSmpTgl] = React.useState(new Date());

  const [tahun, setTahun] = React.useState(new Date().getFullYear());
  let yearNow = new Date().getFullYear();
  const [listYear, setListYear] = React.useState([]);

  const [cardDetailKaltimtara, setCardDetailKaltimtara] = React.useState(false);
  const bulanData = dataGrafikUserKaltimtara.map((item) => item.bulan);

  //========================KALTENG========================================
  const totalTargetKalteng = hasilPresentaseKalteng > 100;

  const [totalNominalTargetKalteng, setTotalNominalTargetKalteng] =
    React.useState(0);

  const [hasilPresentaseKalteng, setHasilPresentaseKalteng] = React.useState(0);
  const [totalNominalPencairanKalteng, setTotalNominalPencairanKalteng] =
    React.useState(0);

  //========================SULUTGO======================================
  const cardTotalAreaManagerSulutgo = useSelector(
    (state) => state.dashboardUtamaReducerSulutgo,
  );
  // const cardTotalPencairan = useSelector((state) => state.pengajuanReducerSulutgo);
  // console.log(cardTotalPencairan.data, "Dari Store");
  const cardTotalPengajuanSulutgo = useSelector(
    (state) => state.dashboardUtamaReducerSulutgo,
  );
  const [totalNominalTargetSulutgo, setTotalNominalTargetSulutgo] =
    React.useState(0);
  const [hasilPresentaseSulutgo, setHasilPresentaseSulutgo] = React.useState(0);
  const [totalNominalPencairanSulutgo, setTotalNominalPencairanSulutgo] =
    React.useState(0);

  //=============================KALSEL=================================
  const [totalNominalPencairanKalsel, setTotalNominalPencairanKalsel] =
    React.useState(0);
  const [hasilPresentaseKalsel, setHasilPresentaseKalsel] = React.useState(0);
  const [totalNominalTargetKalsel, setTotalNominalTargetKalsel] =
    React.useState(0);
  //=======================================================================
  //======================KALTIMTARA========================================
  React.useEffect(() => {
    if (
      totalNominalTargetKaltimtara !== 0 &&
      totalNominalPencairanKaltimtara !== 0
    ) {
      const presentase = Math.round(
        (totalNominalPencairanKaltimtara / totalNominalTargetKaltimtara) * 100,
      );
      setHasilPresentaseKaltimtara(presentase);
    }
  }, [totalNominalPencairanKaltimtara, totalNominalTargetKaltimtara]);

  React.useEffect(() => {
    getTotalPencairanKaltimtara(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalPencairan = response.data.totalNominal;
      setTotalNominalPencairanKaltimtara(totalPencairan);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalTargetUserKaltimtara(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalTargetKaltimtara = response.data.totalTarget;
      setTotalNominalTargetKaltimtara(totalTargetKaltimtara);
    });
  }, [dariTgl, smpTgl]);

  const getListYear = () => {
    let tmp = [];
    for (let i = 5; i >= 0; i--) {
      let years = yearNow--;
      tmp.push({
        value: years,
        label: years,
      });
    }
    setListYear(tmp);
  };
  //==========================KALTENG=====================================
  React.useEffect(() => {
    if (totalNominalPencairanKalteng !== 0 && totalNominalTargetKalteng !== 0) {
      const presentase = Math.round(
        (totalNominalPencairanKalteng / totalNominalTargetKalteng) * 100,
      );
      setHasilPresentaseKalteng(presentase);
    } else {
      setHasilPresentaseKalteng(0);
    }
  }, [totalNominalPencairanKalteng, totalNominalTargetKalteng]);

  React.useEffect(() => {
    getTotalTargetUserKalteng(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalTarget = response.data.totalTarget;
      setTotalNominalTargetKalteng(totalTarget);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalPencairanKalteng(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalPencairan = response.data.totalNominal;
      setTotalNominalPencairanKalteng(totalPencairan);
    });
  }, [dariTgl, smpTgl]);
  //===================================SULUTGO==============================

  React.useEffect(() => {
    if (totalNominalPencairanSulutgo !== 0 && totalNominalTargetSulutgo !== 0) {
      const presentase = Math.round(
        (totalNominalPencairanSulutgo / totalNominalTargetSulutgo) * 100,
      );
      setHasilPresentaseSulutgo(presentase);
    } else {
      setHasilPresentaseSulutgo(0);
    }
  }, [totalNominalPencairanSulutgo, totalNominalTargetSulutgo]);
  React.useEffect(() => {
    getTotalTargetUserSulutgo(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalTarget = response.data.totalTarget;
      setTotalNominalTargetSulutgo(totalTarget);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalPencairanSulutgo(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalPencairan = response.data.totalNominal;
      setTotalNominalPencairanSulutgo(totalPencairan);
    });
  }, [dariTgl, smpTgl]);

  //===========================KALSEL=================================
  React.useEffect(() => {
    if (totalNominalTargetKalsel !== 0 && totalNominalPencairanKalsel !== 0) {
      const presentaseKalsel = Math.round(
        (totalNominalPencairanKalsel / totalNominalTargetKalsel) * 100,
      );
      setHasilPresentaseKalsel(presentaseKalsel);
    } else {
      setHasilPresentaseKalsel(0);
    }
  }, [totalNominalPencairanKalsel, totalNominalTargetKalsel]);

  React.useEffect(() => {
    getTotalPencairanKalsel(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalPencairanKalsel = response.data.totalNominal;
      setTotalNominalPencairanKalsel(totalPencairanKalsel);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    getTotalTargetUserKalsel(dispatch, {
      tglAwal: moment(dariTgl).format("YYYY-MM-DD"),
      tglAkhir: moment(smpTgl).format("YYYY-MM-DD"),
    }).then((response) => {
      const totalTargetKalsel = response.data.totalTarget;
      setTotalNominalTargetKalsel(totalTargetKalsel);
    });
  }, [dariTgl, smpTgl]);

  React.useEffect(() => {
    if (auth.role === "super admin") {
      const interval = setInterval(() => {
        window.location.reload();
        refresh();
      }, 300000);

      return () => clearInterval(interval);
    }
  }, [auth.role]);
  return (
    <>
      <Card
        className="border-0 bg-transparent w-100"
        style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}
      >
        <Container fluid className="px-0">
          {/* =========================================================================
        1. PANEL FILTER TANGGAL & LOGO VENDOR
        ========================================================================= */}
          <Card
            className="mb-3 border-0 filter-card-alive"
            style={{ borderRadius: "16px", overflow: "hidden" }}
          >
            <Card.Body className="p-4">
              <Row className="align-items-center">
                <Col
                  md="4"
                  className="d-flex justify-content-center justify-content-md-start mb-3 mb-md-0"
                >
                  <div style={{ width: "180px", padding: "4px" }}>
                    <img
                      src={require("../assets/img/logo_bap.png").default}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                      alt="Vendor"
                    />
                  </div>
                </Col>
                <Col
                  md="8"
                  className="d-flex justify-content-center justify-content-md-end"
                >
                  <Row className="g-3 w-100 justify-content-end">
                    <Col xs="12" sm="6" md="5" lg="4">
                      <h5
                        className="text-secondary mb-2"
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Tanggal Awal
                      </h5>
                      <div
                        style={{
                          borderRadius: "10px",
                          overflow: "hidden",
                          border: "1px solid #E2E8F0",
                        }}
                      >
                        <ReactDatetime
                          inputProps={{
                            className:
                              "form-control border-0 bg-white py-2 text-center font-weight-bold",
                            placeholder: "Pilih Tanggal",
                          }}
                          onChange={(e) =>
                            setDariTgl(e.toDate().setHours(0, 0, 0, 0))
                          }
                          value={dariTgl}
                          initialValue={dariTgl}
                          timeFormat={false}
                        />
                      </div>
                    </Col>
                    <Col xs="12" sm="6" md="5" lg="4">
                      <h5
                        className="text-secondary mb-2"
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Tanggal Akhir
                      </h5>
                      <div
                        style={{
                          borderRadius: "10px",
                          overflow: "hidden",
                          border: "1px solid #E2E8F0",
                        }}
                      >
                        <ReactDatetime
                          inputProps={{
                            className:
                              "form-control border-0 bg-white py-2 text-center font-weight-bold",
                            placeholder: "Pilih Tanggal",
                          }}
                          onChange={(e) =>
                            setSmpTgl(e.toDate().setHours(23, 59, 0, 0))
                          }
                          value={smpTgl}
                          initialValue={smpTgl}
                          timeFormat={false}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* =========================================================================
        2. GRID MONITORING CARD ALL BPD (Border Radius Sempurna Atas & Bawah)
        ========================================================================= */}
          <Row className="row-gap-max-mewah">
            {/* =================== CARD KALTIMTARA ======================== */}
            {openKaltimCard ? (
              <Col
                xs="12"
                md={!openKaltim ? "6" : "12"}
                className="mb-4 transition-all"
              >
                <Card
                  className="border-0 h-100 card-glow-alive"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                  <div
                    className="px-4 py-3-5 d-flex justify-content-between align-items-center header-gradient"
                    style={{ "--bg-header": "#569DAA" }}
                  >
                    <b
                      style={{
                        color: "white",
                        textTransform: "uppercase",
                        fontSize: "14.5px",
                        letterSpacing: "0.8px",
                        fontWeight: "800",
                      }}
                    >
                      BPD KALTIMTARA
                    </b>
                    <Button
                      className="btn-sm border-0 font-weight-bold px-4 py-2 custom-btn"
                      style={{
                        backgroundColor: openKaltim
                          ? "#EF4444"
                          : "rgba(255, 255, 255, 0.25)",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        const s = !openKaltim;
                        setOpenKaltim(s);
                        setOpenKalsel(false);
                        setOpenKalteng(false);
                        setOpenSulutgo(false);
                        setOpenKaltimCard(true);
                        setOpenKalselCard(!s);
                        setOpenKaltengCard(!s);
                        setOpenSulutgoCard(!s);
                      }}
                    >
                      {openKaltim ? "Tutup Detail" : "Detail"}
                    </Button>
                  </div>

                  <Card.Body className="p-4-5 d-flex flex-column justify-content-center">
                    <Row className="align-items-center g-4 layout-box-inside">
                      <Col
                        xs="12"
                        sm="5"
                        className="d-flex justify-content-center align-items-center text-center logo-wrapper-mewah"
                      >
                        <Image
                          src={
                            "https://mpp.samarindakota.go.id/storage/media_pro/63/6.png"
                          }
                          className="logo-img-mewah"
                        />
                      </Col>
                      <Col
                        xs="12"
                        sm="7"
                        className="d-flex flex-column justify-content-center"
                      >
                        <div className="w-100 inner-data-container">
                          <Row className="g-2 text-center mb-3">
                            <Col xs="6">
                              <small className="mewah-label">Pencapaian</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{
                                  color:
                                    hasilPresentaseKaltimtara > 100
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                {hasilPresentaseKaltimtara} %
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">Target</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{ color: "#26DB53" }}
                              >
                                100%
                              </span>
                            </Col>
                          </Row>
                          <Row className="g-2 text-center border-top pt-3">
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Pencairan
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{
                                  color:
                                    totalNominalPencairanKaltimtara >
                                    totalNominalTargetKaltimtara
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                Rp{" "}
                                {totalNominalPencairanKaltimtara.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Target
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{ color: "#26DB53" }}
                              >
                                Rp{" "}
                                {totalNominalTargetKaltimtara.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}

            {/* =================== CARD KALTENG ======================== */}
            {openKaltengCard ? (
              <Col
                xs="12"
                md={!openKalteng ? "6" : "12"}
                className="mb-4 transition-all"
              >
                <Card
                  className="border-0 h-100 card-glow-alive"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                  <div
                    className="px-4 py-3-5 d-flex justify-content-between align-items-center header-gradient"
                    style={{ "--bg-header": "#0A2647" }}
                  >
                    <b
                      style={{
                        color: "white",
                        textTransform: "uppercase",
                        fontSize: "14.5px",
                        letterSpacing: "0.8px",
                        fontWeight: "800",
                      }}
                    >
                      BPD KALTENG
                    </b>
                    <Button
                      className="btn-sm border-0 font-weight-bold px-4 py-2 custom-btn"
                      style={{
                        backgroundColor: openKalteng
                          ? "#EF4444"
                          : "rgba(255, 255, 255, 0.25)",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        const s = !openKalteng;
                        setOpenKaltim(false);
                        setOpenKalteng(s);
                        setOpenKalsel(false);
                        setOpenSulutgo(false);
                        setOpenKaltimCard(!s);
                        setOpenKaltengCard(true);
                        setOpenKalselCard(!s);
                        setOpenSulutgoCard(!s);
                      }}
                    >
                      {openKalteng ? "Tutup Detail" : "Detail"}
                    </Button>
                  </div>

                  <Card.Body className="p-4-5 d-flex flex-column justify-content-center">
                    <Row className="align-items-center g-4 layout-box-inside">
                      <Col
                        xs="12"
                        sm="5"
                        className="d-flex justify-content-center align-items-center text-center logo-wrapper-mewah"
                      >
                        <Image
                          src={
                            "https://play-lh.googleusercontent.com/azwZR9eqQqXKa_sLsQoMmiYFhi_MJ72rFT2kUcEpFyeVFmMXMQTbXqrY3K2Ok4AlVw"
                          }
                          className="logo-img-mewah"
                        />
                      </Col>
                      <Col
                        xs="12"
                        sm="7"
                        className="d-flex flex-column justify-content-center"
                      >
                        <div className="w-100 inner-data-container">
                          <Row className="g-2 text-center mb-3">
                            <Col xs="6">
                              <small className="mewah-label">Pencapaian</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{
                                  color:
                                    hasilPresentaseKalteng > 100
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                {hasilPresentaseKalteng} %
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">Target</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{ color: "#26DB53" }}
                              >
                                100%
                              </span>
                            </Col>
                          </Row>
                          <Row className="g-2 text-center border-top pt-3">
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Pencairan
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{
                                  color:
                                    totalNominalPencairanKalteng >
                                    totalNominalTargetKalteng
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                {formatRupiah(totalNominalPencairanKalteng)}
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Target
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{ color: "#26DB53" }}
                              >
                                Rp{" "}
                                {totalNominalTargetKalteng.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}

            {/* =================== CARD SULUTGO ======================== */}
            {openSulutgoCard ? (
              <Col
                xs="12"
                md={!openSulutgo ? "6" : "12"}
                className="mb-4 transition-all"
              >
                <Card
                  className="border-0 h-100 card-glow-alive"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                  <div
                    className="px-4 py-3-5 d-flex justify-content-between align-items-center header-gradient"
                    style={{ "--bg-header": "#825F87" }}
                  >
                    <b
                      style={{
                        color: "white",
                        textTransform: "uppercase",
                        fontSize: "14.5px",
                        letterSpacing: "0.8px",
                        fontWeight: "800",
                      }}
                    >
                      BPD SULUTGO
                    </b>
                    <Button
                      className="btn-sm border-0 font-weight-bold px-4 py-2 custom-btn"
                      style={{
                        backgroundColor: openSulutgo
                          ? "#EF4444"
                          : "rgba(255, 255, 255, 0.25)",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        const s = !openSulutgo;
                        setOpenKaltim(false);
                        setOpenKalteng(false);
                        setOpenSulutgo(s);
                        setOpenKalsel(false);
                        setOpenKaltimCard(!s);
                        setOpenKaltengCard(!s);
                        setOpenSulutgoCard(true);
                        setOpenKalselCard(!s);
                      }}
                    >
                      {openSulutgo ? "Tutup Detail" : "Detail"}
                    </Button>
                  </div>

                  <Card.Body className="p-4-5 d-flex flex-column justify-content-center">
                    <Row className="align-items-center g-4 layout-box-inside">
                      <Col
                        xs="12"
                        sm="5"
                        className="d-flex justify-content-center align-items-center text-center logo-wrapper-mewah"
                      >
                        <Image
                          src={require("assets/img/logo-sulutgo.png").default}
                          className="logo-img-mewah"
                        />
                      </Col>
                      <Col
                        xs="12"
                        sm="7"
                        className="d-flex flex-column justify-content-center"
                      >
                        <div className="w-100 inner-data-container">
                          <Row className="g-2 text-center mb-3">
                            <Col xs="6">
                              <small className="mewah-label">Pencapaian</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{
                                  color:
                                    hasilPresentaseSulutgo > 100
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                {hasilPresentaseSulutgo} %
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">Target</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{ color: "#26DB53" }}
                              >
                                100%
                              </span>
                            </Col>
                          </Row>
                          <Row className="g-2 text-center border-top pt-3">
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Pencairan
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{
                                  color:
                                    totalNominalPencairanSulutgo >
                                    totalNominalTargetSulutgo
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                Rp{" "}
                                {totalNominalPencairanSulutgo.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Target
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{ color: "#26DB53" }}
                              >
                                Rp{" "}
                                {totalNominalTargetSulutgo.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}

            {/* =================== CARD KALSEL ======================== */}
            {openKalselCard ? (
              <Col
                xs="12"
                md={!openKalsel ? "6" : "12"}
                className="mb-4 transition-all"
              >
                <Card
                  className="border-0 h-100 card-glow-alive"
                  style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                  <div
                    className="px-4 py-3-5 d-flex justify-content-between align-items-center header-gradient"
                    style={{ "--bg-header": "#67689E" }}
                  >
                    <b
                      style={{
                        color: "white",
                        textTransform: "uppercase",
                        fontSize: "14.5px",
                        letterSpacing: "0.8px",
                        fontWeight: "800",
                      }}
                    >
                      BPD KALSEL
                    </b>
                    <Button
                      className="btn-sm border-0 font-weight-bold px-4 py-2 custom-btn"
                      style={{
                        backgroundColor: openKalsel
                          ? "#EF4444"
                          : "rgba(255, 255, 255, 0.25)",
                        color: "white",
                        borderRadius: "8px",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        const s = !openKalsel;
                        setOpenKaltim(false);
                        setOpenKalteng(false);
                        setOpenSulutgo(false);
                        setOpenKalsel(s);
                        setOpenKaltimCard(!s);
                        setOpenKaltengCard(!s);
                        setOpenSulutgoCard(!s);
                        setOpenKalselCard(true);
                      }}
                    >
                      {openKalsel ? "Tutup Detail" : "Detail"}
                    </Button>
                  </div>

                  <Card.Body className="p-4-5 d-flex flex-column justify-content-center">
                    <Row className="align-items-center g-4 layout-box-inside">
                      <Col
                        xs="12"
                        sm="5"
                        className="d-flex justify-content-center align-items-center text-center logo-wrapper-mewah"
                      >
                        <Image
                          src={require("assets/img/bank-kalsel.png").default}
                          className="logo-img-mewah"
                        />
                      </Col>
                      <Col
                        xs="12"
                        sm="7"
                        className="d-flex flex-column justify-content-center"
                      >
                        <div className="w-100 inner-data-container">
                          <Row className="g-2 text-center mb-3">
                            <Col xs="6">
                              <small className="mewah-label">Pencapaian</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{
                                  color:
                                    hasilPresentaseKalsel > 100
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                {hasilPresentaseKalsel} %
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">Target</small>
                              <span
                                className="d-block mewah-font-number"
                                style={{ color: "#26DB53" }}
                              >
                                100%
                              </span>
                            </Col>
                          </Row>
                          <Row className="g-2 text-center border-top pt-3">
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Pencairan
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{
                                  color:
                                    hasilPresentaseKalsel > 100
                                      ? "#26DB53"
                                      : "#FF4D4F",
                                }}
                              >
                                Rp{" "}
                                {totalNominalPencairanKalsel.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                            <Col xs="6">
                              <small className="mewah-label">
                                Total Target
                              </small>
                              <span
                                className="d-block mewah-font-nominal"
                                style={{ color: "#26DB53" }}
                              >
                                Rp{" "}
                                {totalNominalTargetKalsel.toLocaleString(
                                  "id-ID",
                                )}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ) : null}
          </Row>

          {/* =========================================================================
        3. CONTAINER DETAIL SUB-KOMPONEN BPD ACTIVE
        ========================================================================= */}
          <div className="w-100 mt-2">
            {openKaltim && <DetailKaltimtara />}
            {openKalsel && <DetailKalsel />}
            {openKalteng && <DetailKalteng />}
            {openSulutgo && <DetailSulutgo />}
          </div>
        </Container>
      </Card>

      {/* CSS Core Glow Shadow Premium */}
      <style>{`
  .py-3-5 { padding-top: 16px !important; padding-bottom: 16px !important; }
  .p-4-5 { padding: 32px 28px !important; }
  
  .filter-card-alive {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.04) !important;
  }

  /* MAIN CARD: GLOW SHADOW DENGAN BORDER RADIUS ATAS-BAWAH SEMPURNA */
  .card-glow-alive {
    border-radius: 20px !important; /* Nilai lengkungan luar */
    background: #FFFFFF !important;
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.08), 
      0 12px 24px -8px rgba(0, 0, 0, 0.04),
      0 0 2px 1px rgba(0, 0, 0, 0.02) !important;
    border: 1px solid rgba(241, 245, 249, 0.8) !important;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease-in-out;
  }
  
  .card-glow-alive:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 35px 60px -15px rgba(0, 0, 0, 0.14), 
      0 20px 30px -10px rgba(0, 0, 0, 0.06),
      0 0 20px 2px rgba(94, 157, 170, 0.12) !important;
  }

  /* Header Gradient Sync dengan Border Radius Atas Card */
  .header-gradient {
    background: linear-gradient(135deg, var(--bg-header) 0%, rgba(30, 41, 59, 0.9) 100%) !important;
    border-top-left-radius: 20px !important;   /* Menyelaraskan sudut kiri atas */
    border-top-right-radius: 20px !important;  /* Menyelaraskan sudut kanan atas */
  }

  /* LOGO BANK WORKSPACE */
  .logo-wrapper-mewah {
    min-height: 120px;
    padding-right: 15px;
  }
  .logo-img-mewah {
    max-height: 115px !important;
    max-width: 100%;
    object-fit: contain;
    filter: drop-shadow(0 8px 16px rgba(0,0,0,0.05));
  }

  /* INNER LABELS */
  .mewah-label { 
    font-size: 13px !important; 
    color: #64748B !important; 
    font-weight: 700 !important; 
    text-transform: uppercase; 
    letter-spacing: 0.6px; 
    display: block; 
    margin-bottom: 5px;
  }
  
  .mewah-font-number {
    font-size: 34px !important;
    font-weight: 800 !important;
    line-height: 1;
    letter-spacing: -0.5px;
  }
  
  .mewah-font-nominal {
    font-size: 16.5px !important;
    font-weight: 700 !important;
    letter-spacing: -0.2px;
  }

  .row-gap-max-mewah {
    row-gap: 2.8rem !important; 
  }

  .transition-all { transition: all 0.3s ease; }
  .custom-btn { transition: all 0.2s; border: 1px solid rgba(255,255,255,0.15) !important; }
  .custom-btn:hover { background-color: #FFFFFF !important; color: #1E293B !important; }
`}</style>
    </>
  );
}

export default DashboardUtama;
